import Vue from 'vue'

export const WorkflowEvent = new Vue()
